const Premium = {
    ACTIVE_CONTRACTS: 40,
    HYPER_ROUTES: 20,
    FITOUTS_SAVED: 10,
  IMAGE_HOSTING: 20
};

export default Premium;
